

import CustomerInvoiceBeforePay from "./CustomerInvoiceBeforePay";
import { normalizeOrderForPrint } from "../printNormalizer";

// 📌 **CustomerInvoiceTemplate** - قالب فاتورة العميل

// 📌 **handleBrowserPrintBeforePay** - دالة طباعة الفاتورة عبر المتصفح قبل الدفع
export const handleBrowserPrintBeforePay = async (orderDetails, invoiceData, orderId,   canManageOrders) => {
  if (!canManageOrders || typeof canManageOrders !== "function") {
    console.warn("canManageOrders is not a function");
  }
    const userCanPrintMultipleTimes = canManageOrders(); // ⚠️ هنا صحيح لأنك دلوقتي مررتها كدالة
  // ✅ استلام بيانات الحسابات كما هي من TableOrderInfo بدون override
  const invoiceDataForPrint = { ...(invoiceData || {}) };
  const normalizedOrder = normalizeOrderForPrint(orderDetails);
  const printedKey = `order_printed_${orderId}`;
  const alreadyPrinted = localStorage.getItem(printedKey);

   if (!userCanPrintMultipleTimes && alreadyPrinted) {
    alert("تمت طباعة هذا الطلب بالفعل. لا يمكنك الطباعة مرة أخرى.");
    return;
  }

  // بعد الطباعة احفظ العلامة للكاشير
  if (!userCanPrintMultipleTimes) {
    localStorage.setItem(printedKey, "true");
  }
  const printWindow = window.open("", "printWindow", "width=400,height=600");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  // ✅ ابعت بيانات TableOrderInfo مباشرة للقالب
  const html = await CustomerInvoiceBeforePay(normalizedOrder, invoiceDataForPrint, orderId);

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();

  const tryClose = () => {
    try {
      if (printWindow && !printWindow.closed) printWindow.close();
    } catch (e) {}
  };

  printWindow.onafterprint = tryClose;
  try {
    printWindow.addEventListener &&
      printWindow.addEventListener("afterprint", tryClose);
  } catch (e) {}

  const fallbackTimer = setTimeout(() => tryClose(), 12000);

  const safePrint = async () => {
    try {
      if (printWindow.__waitForAssets) {
        await printWindow.__waitForAssets();
      } else {
        await new Promise((r) => setTimeout(r, 400));
      }
    } catch (e) {}

    try {
      printWindow.print();
    } catch (e) {
      console.error("❌ فشل أمر الطباعة", e);
    }
  };

  await safePrint();

  const pollInterval = setInterval(() => {
    if (!printWindow || printWindow.closed) {
      clearInterval(pollInterval);
      clearTimeout(fallbackTimer);
    }
  }, 500);
};
